import React, { FC } from 'react'
import { largeContent } from '../Layout'
import { FlexBox } from '@ui'
import { ScrollEndProps } from './types';
import settings from '@settings'
import LinkText from './components/LinkText'
import NextPage from './components/NextPage'
import { useMediaQuery } from 'usehooks-ts';

const ScrollEnd: FC<ScrollEndProps> = ({nextPage, height=['100vh']}) => {
    const isTableOrMobile = useMediaQuery('(max-width: 768px)');
    
    if (isTableOrMobile) return (
        <div>
            <div key='end' css={largeContent({isFirst: false, padding: false, background: 'transparent', height})} >
                <FlexBox direction='row' align='center' justify='center'styles={{height: '100%', width: '100%', position: 'relative'}} changeToColumn>
                    <FlexBox direction='column' align='center' justify='center' gap='20px' styles={{backgroundColor: settings.colors.light, width: '100%', height: '100%'}}>
                        <LinkText />
                    </FlexBox>
                </FlexBox>
            </div>
            {nextPage && (
                <NextPage nextPage={nextPage} />
            )}
        </div>
    )


    return (
        <div key='end' css={largeContent({isFirst: false, padding: false, background: 'transparent', height})} >
            <FlexBox direction='row' align='center' justify='center'styles={{height: '100%', width: '100%', position: 'relative'}} changeToColumn>
                <FlexBox direction='column' align='center' justify='center' gap='20px' styles={{backgroundColor: settings.colors.light, width: '100%', height: '100%'}}>
                    <LinkText />
                </FlexBox>
                {nextPage && (
                    <NextPage nextPage={nextPage} />
                )}
            </FlexBox>
        </div>
    )
}

export default ScrollEnd